﻿import angular from 'angular';
import "root/app.module";

angular.module('folkeuni').component('app', {
	template: '<ng-transclude></ng-transclude>',
	transclude: true,
	controller: function (ResponsiveBackgroundImage, $scope, $window, $timeout) {
		var $ctrl = this;
		$ctrl.minimizedHeader = false;
		ResponsiveBackgroundImage.initialize();

		$scope.$on('updateFavorites', function (e, data) {
			$scope.$broadcast('changeFavorites', data);
		})

		$ctrl.test = function () {
			$scope.$broadcast('activateMenu', true);
		}

		$ctrl.minimize = function () {
			if ($window.scrollY >= 90 && !$ctrl.minimizedHeader) {
				document.getElementsByTagName("body")[0].classList.add("minimized");
				$ctrl.minimizedHeader = true;
				$scope.$apply();
			} else if ($window.scrollY < 90 && $ctrl.minimizedHeader) {

				document.getElementsByTagName("body")[0].classList.remove("minimized");
				$ctrl.minimizedHeader = false;

				$scope.$apply();
			}
		}

		$ctrl.$onInit = function () {
			$ctrl.minimize();

			$timeout(function () {
				if (document.getElementsByClassName("CookieDeclaration").length > 0) {

					if (typeof document.getElementsByClassName("CookieDeclaration") !== 'undefined') {
						var elem = document.getElementsByClassName("CookieDeclaration")[0].parentNode.parentNode;

						if (typeof elem !== 'undefined' && typeof elem.childNodes !== 'undefined') {
							elem.removeChild(elem.childNodes[1]);
						}
					}

				}
			}, 2000);

		};

		angular.element($window).bind('scroll', function (evt) {
			$ctrl.minimize();
		});
	}


});

if (document.querySelector(".beskrivelseafarrangementet textarea") != null) {
	document.querySelector(".beskrivelseafarrangementet textarea").setAttribute("maxlength", "499");
}

import './cart-mini';
import './navigation/mobile-navigation';
import './navigation/product-categories';
import './user/new-contracts';
import './user/contracts-calendar';
import './user/participants-list';
import './search-hero/search-hero-voucher';

import './user/contracts-list-expences';
import './user/contracts-list-materials';
import './user/customer-orders';
import './user/login';
import './user/user-activate';
import './user/user-create';
import './user/user-edit';
import './user/user-reset-password';
import './user/user-forgot-password';
import './voucher';
import './checkout';
import './receipt';
import './products/configuration';
import './system/newsletter';
import './products-related';
import './products-list';
import './products-list/product-list-favorit';
import './products/product-detail';
import './evaluation/imports';
import './w-product/imports';
import './stepform/StepForm';
import './stepform/StepNavItem';
import './stepform/StepNotFound';
import './products/product-carousel';
import './service-login';
import './employee-related-products';
import './cookie-warning';
import './redirector';
import './search';
import './favorite-list';
import './donation';
import '../services/ResponsiveBackgroundImageService';
import './alert-box';
import './svg';
import './toast';
import './modal';
import './icons';
import './w-icon/import';